import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=2183f4e4&scoped=true"
import script from "./Popups.vue?vue&type=script&lang=js"
export * from "./Popups.vue?vue&type=script&lang=js"
import style0 from "./Popups.vue?vue&type=style&index=0&id=2183f4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2183f4e4",
  null
  
)

export default component.exports